export default class EDAttribList {

    add(pName, pValue) {
        if(typeof pValue != "undefined") {
            this._attribList.set(pName, pValue)
            if(this._parent._DOMElement) {
                this._parent._DOMElement.setAttribute(pName, pValue)
            }
        }
    }

    has(pName) {
        return this._attribList.has(pName)
    }

    remove(pName) {
        this._attribList.delete(pName)
        if(this._parent._DOMElement) {
            this._parent._DOMElement.removeAttribute(pName)
        }
    }

    get(pName) {
        return this._attribList.get(pName)
    }

    render() {

        this._attribList.forEach((value, name) => {
            this._parent._DOMElement.setAttribute(name, value)
        })
    }

    constructor(pParent, pAttrib) {

        this._parent = pParent
        this._attribList = new Map()

        if(
            pAttrib 
            && typeof pAttrib === 'object' 
            && pAttrib !== null
        ) {

            Object.entries(pAttrib).forEach(([name, value]) => {
                this.add(name, value)
            })
        }

    }

}